"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ListingBannerView = ({ filteredMakeModel, }) => react_1.default.createElement("div", { className: "subscription-listing-banner" },
    react_1.default.createElement("h1", { className: "title" }, `Operativní leasing ${filteredMakeModel}`),
    react_1.default.createElement("ul", { className: "list" },
        react_1.default.createElement("li", { className: "item" }, "Do 3 t\u00FDdn\u016F jezd\u00EDte"),
        react_1.default.createElement("li", { className: "item" }, "Plat\u00EDte jednu \u010D\u00E1stku m\u011Bs\u00ED\u010Dn\u011B"),
        react_1.default.createElement("li", { className: "item" },
            react_1.default.createElement("span", null,
                "V\u0161e vy\u0159\u00EDd\u00EDme\u00A0",
                react_1.default.createElement("span", { className: "no-wrap" }, "online")))));
exports.default = ListingBannerView;
